<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import Steps from '../../navigator/progress/Steps.svelte';
    import stepProgressHelperFactory from '../stepProgressHelper.js';
    import { screenSize } from '../../../../screenSizeStore.js';

    /**
     * Component to display test progress and/or test navigation
     */

    /**
     * @typedef {Object} Props
     * @property {String} serviceCallId -  id of test session
     * @property {Boolean} [disabled]
     * @property {Boolean} [showScore]
     * @property {Function} onMove
     * @property {Function} onOverview
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        serviceCallId,
        disabled = false,
        showScore = false,
        onMove,
        onOverview
    } = $props();

    let stepCreator = $derived(stepProgressHelperFactory({ showScore }));
</script>

<style>
    .progress-container {
        @add-mixin flex-center-center;
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        padding-block: 0;
        padding-inline: 0.375rem 1rem;
    }

    /* Mobile UI modifications */
    @media screen and (--mq-maxwidth-medium) {
        .progress-container > :global(button) {
            margin: 0;
        }
    }
</style>

{#if !$screenSize.mobile}
    <div class="progress-container">
        <Steps {onMove} {onOverview} onMore={onOverview} {serviceCallId} {disabled} {stepCreator} />
    </div>
{/if}
